<template>
  <div class="bay-container">
    <div class="ceiling">
      <home-top></home-top>
      <navicat :current="-1" background="#FFFFFF"></navicat>
    </div>
    <!-- <div class="h-top"></div> -->
    <div class="content w-1400">
      <div class="mau">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>
            <router-link to="/shop">商城</router-link>
          </el-breadcrumb-item>
          <el-breadcrumb-item>支付</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="shop-body">
        <div class="title">订单信息</div>
        <div class="body">
          <el-table :data="productList" style="width: 100%" :header-cell-style="{ background: '#E8EBF5' }">
            <el-table-column prop="orderno" label="订单编号" width="180"/>
            <el-table-column prop="product_name" label="产品名称"/>
            <el-table-column prop="cas_no" label="CAS号"/>
            <!--            <el-table-column prop="unit" label="产品规格"/>-->
            <el-table-column prop="unit" label="规格"/>
            <!--            <el-table-column prop="width" label="重量"/>-->
            <el-table-column prop="unit_price" label="单价">
              <template slot-scope="scope">
                {{ scope.row.unit_price }}元
              </template>
            </el-table-column>
            <el-table-column prop="cart_num" label="购买数量"/>
            <el-table-column prop="express_price" label="运费">
              <template slot-scope="scope">
                {{ scope.row.express_price }}元
              </template>
            </el-table-column>
            <el-table-column prop="total_price" label="总价" fixed="right">
              <template slot-scope="scope">
                {{ scope.row.total_price }}元
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="goods-info-other">
          <!--        收货地址-->
          <div class="info-section">
            <div class="section-title">收货地址</div>
            <div class="info-content">
              <div class="info-row">
                <span class="info-label">联系人：</span>
                <span class="info-value">{{ productList[0]?.address?.name || '--' }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">联系方式：</span>
                <span class="info-value">{{ productList[0]?.address?.phone || '--' }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">收货地址：</span>
                <span class="info-value">
                  {{ productList[0]?.address?.province || '' }}
                  {{ productList[0]?.address?.city || '' }}
                  {{ productList[0]?.address?.district || '' }}
                  {{ productList[0]?.address?.address || '' }}
                </span>
              </div>
            </div>
          </div>
          <!-- 发票信息 -->
          <div class="info-section">
            <div class="section-title">发票信息</div>
            <div class="info-content">
              <div class="info-row">
                <span class="info-label">发票抬头：</span>
                <span class="info-value">{{ productList[0]?.invoice?.title || '--' }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">发票税号：</span>
                <span class="info-value">{{ productList[0]?.invoice?.tax_number || '--' }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">开户银行：</span>
                <span class="info-value">{{ productList[0]?.invoice?.bank || '--' }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">电话：</span>
                <span class="info-value">{{ productList[0]?.invoice?.phone || '--' }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">邮箱：</span>
                <span class="info-value">{{ productList[0]?.invoice?.email || '--' }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="title pay-title">联系业务</div>
        <div class="margin-top">
          <div>业务：{{ productList[0]?.yewu?.name }}</div>
          <div>电话：{{ productList[0]?.yewu?.mobile }}</div>
        </div>

        <div class="title pay-title" v-show="showPay">支付方式</div>
        <div v-show="showPay" class="pay-body">
          <div class="pay-item-title">
            <span :class="['pay-type', { active: selectedPayType === 'wechat' }]" @click="selectPay('wechat')">
              微信支付
            </span>
            <!--            <span :class="['pay-type', { active: selectedPayType === 'alipay' }]" @click="selectPay('alipay')">-->
            <!--              支付宝支付-->
            <!--            </span>-->
            <span :class="['pay-type', { active: selectedPayType === 'lineDown' }]" @click="selectPay('lineDown')">
              线下汇款
            </span>
          </div>
          <div class="pay-code" v-if="selectedPayType != 'lineDown'">
            <div class="pay-code-title">
              支付金额：{{ detail.total_price || total_price }}元
            </div>
            <div class="load-box">
              <div v-if="loading" class=" sizre-20">
                <i class="el-icon-loading loading-fun"></i>
              </div>
              <canvas class="qrcode" id="qrcode" ref="qrcode"></canvas>
            </div>
            <div class="pay-code-tip" v-if="selectedPayType">
              请使用
              <span class="pay-code-tip-text">{{
                  selectedPayType === "wechat" ? "微信" : "支付宝"
                }}</span>
              扫描二维码完成支付
            </div>
          </div>
          <div v-else class="pay-inner">
            <div class="pay-code-title"> 支付金额：{{ detail.total_price || total_price }}元</div>
            <el-form v-model="formData" :rules="formRules" class="pay-form" label-width="100px" ref="formRules">

              <el-form-item label="汇款方式">
                <el-radio-group v-model="formData.pay_type" prop="pay_type">
                  <el-radio label="remit_alipay">支付宝汇款</el-radio>
                  <el-radio label="remit_bank">银行汇款</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="支付宝二维码" v-if="formData.pay_type=='remit_alipay'">
                <el-image
                    style="width: 120px; height: 120px"
                    :src="configInfo.pay_alipay"
                    fit="scale-down"></el-image>
              </el-form-item>
              <div v-else>
                <el-row>
                  <el-col :span="11">
                    <el-form-item label="账户名称">
                      {{ configInfo.pay_name }}
                      <el-button class="copy-btn" type="text" @click="handleCopy(configInfo.pay_name)">
                        <i class="el-icon-copy-document"></i></el-button>
                    </el-form-item>
                  </el-col>
                  <el-col :span="9">
                    <el-form-item label="银行帐号">
                      {{ configInfo.pay_bank }}
                      <el-button class="copy-btn" type="text" @click="handleCopy(configInfo.pay_bank)">
                        <i class="el-icon-copy-document"></i></el-button>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item label="开户行">
                  {{ configInfo.pay_account }}
                  <el-button class="copy-btn" type="text" @click="handleCopy(configInfo.pay_account)">
                    <i class="el-icon-copy-document"></i></el-button>
                </el-form-item>

              </div>
              <el-form-item label="汇款凭证" v-model="formData.pay_image"
                            prop="pay_image">
                <ImageUpload :maxSize="1" @change="changeImage"></ImageUpload>
              </el-form-item>
            </el-form>
            <el-button type="primary" class="button-style" @click="save">
              提交
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <home-footer></home-footer>
  </div>
</template>
<script>
import homeTop from "@/components/public/home-top.vue";
import homeFooter from "@/components/public/home-footer.vue";
import navicat from "@/components/navicat/navicat.vue";
import ImageUpload from "@/components/public/ImageUpload.vue";
import QRCode from "qrcode";
import {
  get_order_by_orderid,
  unifiedPayment,
  get_order_by_orderno,
} from "@/api/modules/user";
import {
  getConfigByKey
} from "@/api/modules/common";

export default {
  name: "bay",
  components: {
    homeTop,
    navicat,
    homeFooter,
    ImageUpload
  },
  data() {
    return {
      showPay:false,
      order_id: this.$route.query.order_id,
      order_no: this.$route.query.order_no,
      re_pay: this.$route.query.re_pay || 0,
      detail: {},
      loading: false,
      selectedPayType: "wechat", // 默认微信
      productList: [],
      total_price: 0,
      loading_qrcode: true,
      timer: null,
      formData: {
        pay_type: "remit_alipay",
        pay_image: []
      },
      formRules: {
        pay_image: [
          {required: true, message: '请上传汇款凭证', trigger: 'blur'}
        ]
      },
      pay_name: '',
      pay_account: '',
      pay_bank: '',
      pay_alipay: ''
    };
  },
  computed: {
    configInfo() {
      return this.$store.state.config.config;
    },
  },
  mounted() {
    if (this.order_id) {
      this.getOrderInfo();
    } else {
      this.getOrderInfoByNo();
    }

    this.setTimer();

    // 添加页面卸载事件监听器
    window.addEventListener('beforeunload', this.clearTimers);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null; // 清除引用
    }
    // 移除页面卸载事件监听器
    window.removeEventListener('beforeunload', this.clearTimers);
  },
  methods: {
    handleCopy(text) {
      if (navigator.clipboard) {
        navigator.clipboard
            .writeText(text)
            .then(() => {
              this.$message.success({
                message: "复制成功",
                type: "success",
                offset: 100,
              });
            })
            .catch(() => {
              this.$message.error({
                message: "复制失败，请手动复制",
                type: "error",
                offset: 100,
              });
            });
      } else {
        // 兼容老浏览器
        const input = document.createElement("input");
        input.value = text;
        document.body.appendChild(input);
        input.select();
        try {
          document.execCommand("copy");
          this.$message.success({
            message: "复制成功",
            type: "success",
            offset: 100,
          });
        } catch (e) {
          this.$message.error({
            message: "复制失败，请手动复制",
            type: "error",
            offset: 100,
          });
        }
        document.body.removeChild(input);
      }
    },
    // 保存消息
    save() {
      if (this.formData.pay_image.length == 0) {
        this.$message.error({
          message: '请上传汇款凭证',
          offset: 300
        })
        return
      }
      if (this.formData.pay_type && this.formData.pay_image) {
        unifiedPayment({
          pay_type: this.formData.pay_type,
          pay_image: this.formData.pay_image,
          order_id: this.order_id || this.order_no,
          form_field: this.order_id ? 'shop' : 'cart'
        }).then(res => {
          if (res.data.code == 10000) {
            this.$message.success(
                {
                  message: res.data.message,
                  offset: 300
                }
            )
            setTimeout(() => {
              this.$router.push({
                path: "/user/purchase/order",
              });
              clearInterval(this.timer);
            }, 1000)
          }
        })

      } else {
        this.$message.error({
          message: '请完善信息后提交！',
          offset: 300
        })
      }


    },

    // 上传图片
    changeImage(e) {
      this.formData.pay_image = e[0]
    },
    // 开启定时
    setTimer() {
      if (this.order_id) {
        this.timer = setInterval(() => {
          get_order_by_orderid(this.order_id).then((res) => {
            if (res.data.code == 10000) {
              if (res.data.data.status == 2) {
                this.clearTimers();
                this.$router.push({
                  path: "/shop/pay-success",
                  query: {
                    order_id: this.order_id,
                  },
                });
              }
            }
          });
        }, 2000);
      } else {
        this.timer = setInterval(() => {
          get_order_by_orderno(this.order_no).then((res) => {
            if (res.data.code == 10000) {
              let data = res.data.data.list[0];
              if (data.status == 2) {
                this.clearTimers();
                this.$router.push({
                  path: "/shop/pay-success",
                  query: {
                    order_no: this.order_no,
                  },
                });
              }
            }
          });
        }, 2000);
      }
    },

    // 清除定时器的通用方法
    clearTimers() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },

    getOrderInfo() {
      this.loading = true;
      get_order_by_orderid(this.order_id).then((res) => {
        this.detail = res.data.data;
        this.productList = [this.detail]
        this.loading = false;
        this.payFunction();
      });
    },
    // 购物车下单
    getOrderInfoByNo() {
      this.loading = true;
      get_order_by_orderno(this.order_no).then((res) => {
        this.productList = res.data.data.list.map(item => ({
          ...item,
          width: item.unit.split(',')[1],
          purity: item.unit.split(',')[0]
        }));
        this.total_price = res.data.data.total_price;
        this.loading = false;
        this.payMoreFunction();
      });
    },
    selectPay(type) {
      this.selectedPayType = type;
      if (this.selectedPayType != 'lineDown') {
        if (this.order_id) {
          this.payFunction();
        } else {
          this.payMoreFunction();
        }
      }
    },
    async getCode(url) {
      try {
        await QRCode.toCanvas(this.$refs.qrcode, url, {
          width: 200,
          margin: 2,
          color: "#000000",
          background: "#ffffff",
        });
      } catch (err) {
        console.error("生成二维码失败:", err);
      }
    },
    // 购物车支付
    payMoreFunction() {
      let pay_type = "";
      let order_id = this.order_no;
      if (this.selectedPayType === "wechat") {
        pay_type = "wechat_native";
      } else if (this.selectedPayType === "alipay") {
        pay_type = "alipay";
      }
      this.loading = true;
      unifiedPayment({
        order_id: order_id,
        pay_type: pay_type,
        form_field: "cart",
      }).then((res) => {
        this.loading = false;
        if (res.data.code === 10000) {
          if (pay_type == "wechat_native") {
            this.getCode(res.data.data.code_url);
          } else {
            this.getCode(res.data.data.qr_code);
            // 在新页面打开支付成功页面
            // const paySuccessUrl = `/shop/pay-success?order_id=${this.detail.id}`;
            // window.open(paySuccessUrl, '_blank');
          }
        } else {
          this.$message.error({
            message: res.data.message,
            duration: 2000,
            offset: 300,
          });
        }
      });
    },
    payFunction() {
      this.loading = true;
      let pay_type = "";
      if (this.selectedPayType === "wechat") {
        pay_type = "wechat_native";
      } else if (this.selectedPayType === "alipay") {
        pay_type = "alipay";
      }
      let postObj = {
        order_id: this.detail.id,
        pay_type: pay_type,
        form_field: "shop",
      }
      if (this.re_pay) {
        postObj.re_pay = this.re_pay;
      }
      unifiedPayment(postObj).then((res) => {
        this.loading = false;
        if (res.data.code === 10000) {
          if (pay_type === "wechat_native") {
            this.getCode(res.data.data.code_url);
          } else {
            this.getCode(res.data.data.qr_code);
            // window.location.href = res.data.data[0];
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.goods-info-other {
  display: flex;
  gap: 24px;
}

.info-section {
  width: 49%;
  margin: 30px 0;
  padding: 20px;
  background-color: #f9fafc;
  border-radius: 8px;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.03);

  .section-title {
    font-size: 18px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
  }

  .info-content {
    .info-row {
      display: flex;
      margin-bottom: 15px;

      &:last-child {
        margin-bottom: 0;
      }

      .info-label {
        width: 100px;
        font-weight: 500;
        color: #606266;
        flex-shrink: 0;
      }

      .info-value {
        flex: 1;
        color: #303133;
        word-break: break-all;
      }
    }
  }
}

.sizre-20 {
  font-size: 40px;
  position: absolute;
  line-height: 212px;
  padding-left: 10px;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  width: 212px;
  height: 212px;
  background: #ffffff;
  border-radius: 24px;
  opacity: 0.8;
}

.load-box {
  position: relative;
}

.pay-info {
  .pay-info-item {
    display: flex;
    align-items: center;
    text-align: right;
    vertical-align: middle;
    font-size: 14px;
    color: #606266;
    line-height: 40px;
    padding: 0 12px 0 0;
    box-sizing: border-box;

    .pay-info-item-title {
      width: 80px;
      text-align: right;
    }

    .pay-info-item-content {
      margin-left: 30px;

      img {
        width: 150px;
        height: 150px;
      }
    }

    .copy-btn {
      margin-left: 10px;
    }
  }
}

.pay-code-tip-text {
  color: #0c60e6;
  font-weight: bold;
}

.h-top {
  height: 120px;
}

.qrcode {
  width: 200px;
  height: 200px;
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
  /* 关键：合并边框 */
  border: 1px solid #dcdfe2;

  /* 新增样式规则 */
  td:nth-child(1),
  td:nth-child(3),
  td:nth-child(5) {
    width: 110px;
    height: 40px;
    text-align: center;
    font-weight: 400;
    color: #5f616c;
    background-color: #d1e1fb;
  }

  td:nth-child(2),
  td:nth-child(4),
  td:nth-child(6) {
    height: 40px;
    padding-left: 33px;
    font-weight: bold;
    color: #00112b;
  }
}

.content {
  margin-bottom: 100px;

  .mau {
    margin: 20px 0;
  }

  .shop-body {
    padding: 20px;
    background-color: #fff;
    border-radius: 10px;

    .title {
      font-size: 20px;
      font-weight: 600;
      color: #333;
      margin-bottom: 20px;
    }

    .pay-title {
      margin: 20px 0;
    }
  }
}

.pay-body {
  display: flex;
}

.pay-item-title {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 32px;
  margin: 32px 0 24px 0;
}

.pay-code {
  flex: 1;
}

.pay-type {
  padding: 12px 36px;
  border: 2px solid #e0e0e0;
  border-radius: 28px;
  cursor: pointer;
  font-size: 18px;
  color: #666;
  background: #f7faff;
  transition: all 0.2s;
  user-select: none;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(12, 96, 230, 0.04);
}

.pay-type.active {
  border-color: #0c60e6;
  background: #e8ebf5;
  color: #0c60e6;
  font-weight: bold;
  box-shadow: 0 4px 16px rgba(12, 96, 230, 0.1);
}

.pay-type:not(.active):hover {
  border-color: #bdbdbd;
  background: #f0f4fa;
}

.pay-code {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 32px;
  margin-bottom: 24px;
}

.pay-code canvas {
  border: 1.5px solid #e0e0e0;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(12, 96, 230, 0.08);
  background: #fff;
  padding: 12px;
}

.pay-code-tip {
  margin-top: 16px;
  color: #888;
  font-size: 15px;
  letter-spacing: 1px;
}

.pay-code-title {
  font-size: 22px;
  color: #0c60e6;
  font-weight: bold;
  margin-bottom: 18px;
  text-align: center;
  letter-spacing: 1px;
}

.pay-inner {

  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .pay-form {
    display: inline-block;
    width: 60%;
    //width: 400px;


  }

  .button-style {
    width: 200px;
  }
}
</style>
